import { twMerge } from 'tailwind-merge';
import { Box, InputLabel } from '@mui/material';

import { FieldArrayFormField } from 'types';
import { QuestionLabel } from 'components/question-label';

import { DynamicFormFields } from '.';

export const FieldArrayField = ({ label, options }: FieldArrayFormField) => {
  const isHorizontal = options?.layout === 'horizontal';
  return (
    <Box>
      {label && (
        <InputLabel component="div">
          <QuestionLabel value={label} />
        </InputLabel>
      )}
      {options && (
        <>
          <Box
            className={twMerge(
              'flex',
              !isHorizontal && 'flex-col',
              isHorizontal && 'flex-wrap'
            )}
          >
            <DynamicFormFields
              hideLabels
              fields={options.fields}
              container={(field, node, index) => (
                <Box
                  key={field.id}
                  className={twMerge(
                    'flex w-full flex-1 gap-2',
                    !isHorizontal && 'flex-col',
                    isHorizontal && 'max-w-1/2 basis-1/2',
                    index > (isHorizontal ? 1 : -1) && 'mt-2'
                  )}
                >
                  {!isHorizontal && (
                    <InputLabel component="div" className="w-full">
                      <QuestionLabel value={field.label} />
                    </InputLabel>
                  )}
                  <Box
                    className={
                      isHorizontal ? 'flex-1' : 'w-full [&>div]:w-full'
                    }
                  >
                    {node}
                  </Box>
                  {isHorizontal && (
                    <Box className="flex-1">
                      <InputLabel component="div" className="mt-6">
                        <QuestionLabel value={field.label} />
                      </InputLabel>
                    </Box>
                  )}
                </Box>
              )}
            />
          </Box>
        </>
      )}
    </Box>
  );
};
